<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :search="search"
    :options.sync="options"
    :server-items-length="totalItems"
    :loading="loading"
    sort-by="firstName"
    must-sort
    class=""
    calculate-widths
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-toolbar-title>{{ $t('Users') }}</v-toolbar-title>
        <v-spacer></v-spacer>
      <v-text-field
        v-model="options.search"
        append-icon="mdi-magnify"
        :label="$t('Search')"
        single-line
        hide-details
        clearable
        class="shrink mr-5"
      ></v-text-field>
        <v-btn
            :to="{ name: 'UsersCreate' }"
            fab
            dark
            color="primary"
        >
            <v-icon
            dark
            >
            mdi-plus
            </v-icon>
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.role="{ item }">

        {{ getRole(item.role) }}

    </template>
    <template v-slot:item.actions="{item}">
        <v-btn :to="{name: 'UsersEdit', query: { id: item.id, page: options.page }}" plain text icon class="mr-2">
          <v-hover v-slot="{ hover }">
            <v-icon :color="hover? 'green': 'grey'"
            >
            mdi-pencil
            </v-icon>
          </v-hover>
        </v-btn>

        <v-btn :to="{name: 'UsersDelete', query: { id: item.id,name:item.firstName + ' ' + item.lastName, page: options.page }}" plain text icon class="">
            <v-hover v-slot="{ hover }">
              <v-icon  :color="hover? 'primary': 'grey'"
              >
              mdi-delete
              </v-icon>
            </v-hover>
        </v-btn>
    </template>
    <template v-slot:no-data>
      {{ $t('No items found') }}
    </template>
  </v-data-table>
</template>

<script>
    export default {
        data(){
            return{
                search: '',
                totalItems: 0,
                options: {},
                roles:[],
                loading: true,
                headers: [
                    { text: this.$t('First Name'), align: 'start', value: 'firstName',sortable: true},
                    { text: this.$t('Last Name'), value: 'lastName',sortable: true},
                    { text: this.$t('Email'), value: 'email', sortable: true },
                    { text: this.$t('Role'), value: 'role', sortable: false },
                    { text: this.$t('Actions'), align: 'right', value: 'actions', sortable: false },
                ],
                items: []
            }
        },

        watch: {
            options: {
                handler () {
                  this.fetchItems()
                },
                deep: true,
            }
        },
        mounted ()
        {
            if(this.$route.query.page > 0){
              this.options.page = parseInt(this.$route.query.page);
            }

            this.fetchItems();
        },
        created: function()
        {
            this.fetchRoles()
        },

        methods: {
            getRole(roleid){
              let filterRole = this.roles.filter(function(role){
                return role.value == roleid
              })
              return this.$t(filterRole[0].name)
            },
            fetchRoles()
            {
                let uri = this.$urlPrefix + '/Role/GetAll';
                this.axios.get(uri).then((response) => {
                    this.roles = response.data;
                });
            },
            fetchItems()
            {
              this.$router.replace({ query: { page: this.options.page } }).catch(()=>{});

              let uri = this.$urlPrefix + '/User/CountAll';
              let uri2 = this.$urlPrefix + '/User/GetList?start='+ (this.options.page -1) * this.options.itemsPerPage+'&count='+this.options.itemsPerPage;
              if(this.options.search != undefined && this.options.search != ""){
                uri2 += '&search='+this.options.search;
              }
              if(this.options.sortBy){
                uri2 += '&sort='+this.options.sortBy[0];
              }
               if(this.options.sortDesc){
                uri2 += '&sortDescending='+this.options.sortDesc[0];
              }

              this.axios.get(uri).then((response) => {
                  this.totalItems = response.data;
                this.axios.get(uri2).then((response) => {
                    this.items = response.data;
                    this.loading = false;
                });
              });
            },
        }
    }
</script>
